var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2819_5554)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.49168 18.4057H9.9668C10.3709 18.4057 10.6973 18.7321 10.6973 19.1362C10.6973 19.5403 10.3709 19.8668 9.9668 19.8668H2.49168C1.17316 19.8668 0.1 18.7936 0.1 17.4751V2.52492C0.1 1.2064 1.17316 0.133203 2.49168 0.133203H9.9668C10.3709 0.133203 10.6973 0.459747 10.6973 0.863828C10.6973 1.2679 10.3709 1.59438 9.9668 1.59438H2.49168C1.97802 1.59438 1.56113 2.01121 1.56113 2.52492V17.4751C1.56113 17.9888 1.97797 18.4057 2.49168 18.4057Z",
    fill: "#255097",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6324 4.49584L14.6323 4.49573C14.3462 4.21257 13.883 4.21595 13.5994 4.50324C13.316 4.79033 13.3189 5.25269 13.6067 5.53614L13.6068 5.53622L17.2156 9.09766L17.389 9.26884H17.1454H7.47508C7.07101 9.26884 6.74453 9.59532 6.74453 9.99939C6.74453 10.4035 7.07102 10.73 7.47508 10.73H17.1454H17.389L17.2156 10.9011L13.6068 14.4626L13.6067 14.4627C13.3191 14.746 13.3167 15.2083 13.5994 15.4956C13.7428 15.6404 13.9312 15.7133 14.1196 15.7133C14.3054 15.7133 14.4907 15.6432 14.6323 15.503L14.6324 15.5029L19.6822 10.5196C19.6822 10.5196 19.6822 10.5196 19.6823 10.5195C19.8212 10.382 19.9 10.1949 19.9 9.99935C19.9 9.80379 19.822 9.61757 19.6823 9.47924L14.6324 4.49584ZM14.6324 4.49584L19.6822 9.47914L14.6324 4.49584Z",
    fill: "#255097",
    stroke: "white",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2819_5554"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimary);
export default __webpack_public_path__ + "static/media/primary.fb8a1dd62aa56981c3f530b91eecdbca.svg";
export { ForwardRef as ReactComponent };